/* RESET24 · PDP system JS: gallery (thumbs / slider / grid), variant picker, tabs, sticky bar. */
(function () {
  'use strict';
  if (window.__rt) return; window.__rt = true;
  function track(e, d) { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: e }, d || {})); }
  var desk = function () { return window.matchMedia('(min-width: 990px)').matches; };

  function gallery() {
    document.querySelectorAll('[data-rt-gallery]:not([data-b])').forEach(function (g) {
      g.setAttribute('data-b', '1');
      var stage = g.querySelector('.rt-gal__stage');
      var figs = [].slice.call(stage.children);
      var thumbs = [].slice.call(g.querySelectorAll('[data-rt-thumb]'));
      var dots = [].slice.call(g.querySelectorAll('[data-rt-dot]'));
      var thumbMode = /rt-gal--thumbs/.test(g.className);
      var cur = 0;
      function mark(i) {
        cur = i;
        figs.forEach(function (f, k) { f.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i); });
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i); });
      }
      function go(i) {
        i = Math.max(0, Math.min(figs.length - 1, i)); mark(i);
        if (desk() && thumbMode) return;
        if (desk()) figs[i].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        else stage.scrollTo({ left: figs[i].offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      stage.addEventListener('scroll', function () {
        if (desk()) return;
        var i = Math.round(stage.scrollLeft / Math.max(1, figs[0].offsetWidth + 12));
        if (i !== cur && figs[i]) mark(i);
      }, { passive: true });
      g.rtGo = function (mid) { figs.forEach(function (f, k) { if (String(f.getAttribute('data-mid')) === String(mid)) go(k); }); };
      mark(0);
    });
  }

  function main() {
    document.querySelectorAll('[data-rt-main]:not([data-b])').forEach(function (root) {
      root.setAttribute('data-b', '1');
      var data = root.querySelector('[data-variants]'); if (!data) return;
      var variants = JSON.parse(data.textContent);
      var gal = root.querySelector('[data-rt-gallery]');
      var inputs = function () { return [].slice.call(root.querySelectorAll('[data-rt-opt]')); };
      function selected() {
        var o = [];
        inputs().forEach(function (el) {
          if (el.tagName === 'SELECT') o[+el.getAttribute('data-i')] = el.value;
          else if (el.checked) o[+el.getAttribute('data-i')] = el.value;
        });
        return o;
      }
      function update() {
        var o = selected();
        var v = variants.filter(function (x) { return x.options.join('|') === o.join('|'); })[0];
        root.querySelectorAll('[data-rt-optlabel]').forEach(function (l) { var i = +l.getAttribute('data-i'); if (o[i]) l.textContent = o[i]; });
        var out = (root.querySelector('[data-rt-atc]') || {}).getAttribute ? root.querySelector('[data-rt-atc]').getAttribute('data-out') : '';
        var add = root.querySelector('[data-rt-atc]') ? root.querySelector('[data-rt-atc]').getAttribute('data-add') : '';
        var avail = !!(v && v.available);
        document.querySelectorAll('[data-rt-atc], [data-rt-atc-sticky]').forEach(function (b) { b.disabled = !avail; });
        document.querySelectorAll('[data-rt-label]').forEach(function (b) { b.textContent = avail ? add : out; });
        if (!v) return;
        document.querySelectorAll('[data-rt-id]').forEach(function (i) { i.value = v.id; });
        var html = '<span>' + v.price + '</span>' + (v.compare ? '<s>' + v.compare + '</s><span class="rt-save">' + v.save + '</span>' : '');
        document.querySelectorAll('[data-rt-price]').forEach(function (p) { p.innerHTML = html; });
        if (v.media && gal && gal.rtGo) gal.rtGo(v.media);
        if (history.replaceState) history.replaceState(null, '', '?variant=' + v.id);
      }
      root.addEventListener('change', function (e) {
        if (e.target.hasAttribute && e.target.hasAttribute('data-rt-opt')) { track('select_option', { option: e.target.getAttribute('data-name'), value: e.target.value }); update(); }
      });
      root.querySelectorAll('[data-rt-q]').forEach(function (b) {
        b.addEventListener('click', function () { var q = root.querySelector('[data-rt-qty]'); q.value = Math.max(1, (+q.value || 1) + (+b.getAttribute('data-rt-q'))); });
      });
      root.querySelectorAll('form').forEach(function (f) { f.addEventListener('submit', function () { track('add_to_cart'); }); });
      var sticky = root.querySelector('[data-rt-sticky]'), btn = root.querySelector('[data-rt-atc]');
      if (sticky && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { var e = en[0]; sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(btn);
      }
      track('view_item');
    });
  }

  function tabs() {
    document.querySelectorAll('[data-rt-tabs]:not([data-b])').forEach(function (root) {
      root.setAttribute('data-b', '1');
      var t = [].slice.call(root.querySelectorAll('[role="tab"]')), p = [].slice.call(root.querySelectorAll('[role="tabpanel"]'));
      function sel(i, f) { t.forEach(function (b, k) { b.setAttribute('aria-selected', k === i); b.tabIndex = k === i ? 0 : -1; }); p.forEach(function (x, k) { x.hidden = k !== i; }); if (f) t[i].focus(); }
      t.forEach(function (b, i) {
        b.addEventListener('click', function () { sel(i); });
        b.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); sel((i + 1) % t.length, true); } if (e.key === 'ArrowLeft') { e.preventDefault(); sel((i - 1 + t.length) % t.length, true); } });
      });
      sel(0);
    });
  }

  function init() { gallery(); main(); tabs(); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', function () { window.__rt = true; init(); });
})();
